window.$ = window.jQuery = require('jquery');

import 'bootstrap/js/dist/util';
import 'bootstrap/js/dist/modal';
import 'bootstrap/js/dist/collapse';

require('./hamburger');
require('./smooth-scroll');
require('./cookie');
require('./typewriter');
require('./mail');
